(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_products-with-filters"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  document.querySelectorAll('.hcw[data-section-id]').forEach(init);

  function init(root) {
    if (!root || root.dataset.initialized === '1') return;
    root.dataset.initialized = '1';

    const mount          = root.querySelector('.hcw__mount');
    const collectionUrl  = (root.dataset.collectionUrl || '').trim();
    const remoteSection  = (root.dataset.remoteSection || 'main-collection-product-grid').trim();
    const urlKey         = (root.dataset.urlKey || ('hcw_' + (root.dataset.sectionId || ''))).trim();
    const schemeClasses  = (root.dataset.schemeClasslist || '').trim();

    const desiredCols = {
      desktop: parseInt(root.dataset.colsDesktop, 10) || 4,
      tablet:  parseInt(root.dataset.colsTablet, 10)  || 3,
      mobile:  parseInt(root.dataset.colsMobile, 10)  || 2
    };
    const imageRatioChoice = (root.dataset.imageRatio || 'keep').trim();

    if (!mount || !collectionUrl || !remoteSection) { if (mount) mount.innerHTML = ''; return; }

    /* ----------------- Request control (Abort + Debounce) ----------------- */
    let currentFetchAbort = null;

    function debounce(fn, ms){
      let t;
      return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
    }

    const scheduleRender = debounce((absUrl) => {
      setSavedParamsFromUrl(absUrl);
      renderFromUrl(absUrl);
    }, 160);

    /* ----------------- URL state helpers ----------------- */
    function paramsFromURLValue(v){ try { return v ? new URLSearchParams(v) : new URLSearchParams(); } catch(_) { return new URLSearchParams(); } }
    function getSavedParams(){ const v = new URL(location.href).searchParams.get(urlKey); return paramsFromURLValue(v); }
    function setSavedParamsFromUrl(url){
      const next = new URL(location.href);
      const p = new URL(url, location.origin).searchParams;
      const blob = p.toString();
      if (blob) next.searchParams.set(urlKey, blob); else next.searchParams.delete(urlKey);
      history.replaceState({}, '', next.toString());
    }
    window.addEventListener('popstate', () => {
      renderFromUrl(buildBaseUrlWithBlob(getSavedParams()));
    });

    function buildBaseUrlWithBlob(params) {
      const base = new URL(collectionUrl, location.origin);
      const p = new URLSearchParams(params || '');
      p.forEach((v,k)=>{ if (v !== '' && v != null) base.searchParams.append(k,v); });
      return base.toString();
    }

    /* ----------------- Section rendering ----------------- */
    function buildSectionsUrl(fromAbsoluteCollectionUrl){
      const u = new URL(fromAbsoluteCollectionUrl, location.origin);
      u.searchParams.set('sections', remoteSection);
      return u.toString();
    }

    async function fetchSectionFromAbsoluteUrlAbortable(absUrl){
      if (currentFetchAbort) currentFetchAbort.abort();
      currentFetchAbort = new AbortController();
      const signal = currentFetchAbort.signal;

      const res = await fetch(buildSectionsUrl(absUrl), { credentials: 'same-origin', signal });
      if (!res.ok) throw new Error('Fetch ' + res.status);
      const data = await res.json();
      return data?.[remoteSection] ?? data?.sections?.[remoteSection] ?? '';
    }

    /* ----------------- Layout helpers ----------------- */
    function lockHeight(){ const h = Math.ceil(mount.offsetHeight); if (h > 0) mount.style.minHeight = h + 'px'; }
    function unlockHeight(){ mount.style.minHeight = ''; }

    function applyDawnGridOverrides(){
      const grid =
        mount.querySelector('ul.grid.product-grid') ||
        mount.querySelector('.product-grid') ||
        mount.querySelector('ul.grid') ||
        mount.querySelector('.grid');
      if (!grid) return;

      const cls = new Set(grid.classList);
      const usesDesktopVariant = [...cls].some(c => /^grid--\d+-col-desktop$/.test(c));
      const usesTabletVariant  = [...cls].some(c => /^grid--\d+-col-tablet$/.test(c));

      [...cls].forEach(c=>{
        if (/^grid--\d+-col$/.test(c)) cls.delete(c);
        if (/^grid--\d+-col-tablet$/.test(c)) cls.delete(c);
        if (/^grid--\d+-col-desktop$/.test(c)) cls.delete(c);
      });

      if (usesDesktopVariant) cls.add(`grid--${desiredCols.desktop}-col-desktop`);
      if (usesTabletVariant)  cls.add(`grid--${desiredCols.tablet}-col-tablet`);
      cls.add(`grid--${desiredCols.mobile}-col`);
      grid.className = [...cls].join(' ');
    }

    function applyDawnImageRatioOverride(){
      const choice = imageRatioChoice; if (choice === 'keep') return;
      const mediaBlocks = mount.querySelectorAll('.card__media .media, .product-card .media, .media');
      mediaBlocks.forEach(m=>{
        const cls = new Set(m.classList);
        ['media--square','media--portrait','media--landscape','media--adapt'].forEach(tok => cls.delete(tok));
        const map = { square:'media--square', portrait:'media--portrait', landscape:'media--landscape', natural:'media--adapt' };
        const token = map[choice]; if (token) cls.add(token);
        m.className = [...cls].join(' ');
      });
    }

    /* ----------------- Second image hydration ----------------- */
    const productCache = new Map(); // handle -> images[]

    function buildResponsiveAttrs(baseUrl){
      try {
        const u = new URL(baseUrl, location.origin);
        const widths = [165,360,533,720,940,1066];
        const srcset = widths.map(w => {
          const uu = new URL(u.href);
          uu.searchParams.set('width', String(w));
          return `${uu.href} ${w}w`;
        }).join(',');
        const uu = new URL(u.href);
        uu.searchParams.set('width', '533');
        return {
          src: uu.href,
          srcset,
          sizes: '(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)'
        };
      } catch (_) {
        return { src: baseUrl, srcset: '', sizes: '' };
      }
    }

    async function hydrateMissingSecondImage(scopeEl){
      const rootEl = scopeEl || mount;
      const mediaBlocks = rootEl.querySelectorAll('.card__media .media');

      const tasks = Array.from(mediaBlocks).map(async (m) => {
        const visuals = Array.from(m.children).filter(n => n.tagName === 'IMG' || n.tagName === 'PICTURE');
        if (visuals.length >= 2) {
          if (!m.classList.contains('media--hover-effect')) m.classList.add('media--hover-effect');
          return;
        }
        if (visuals.length !== 1) return;

        const card = m.closest('.card');
        const link =
          card?.querySelector('.card__heading a.full-unstyled-link') ||
          card?.querySelector('.card__heading a, .card__content a');
        if (!link) return;

        const href = link.getAttribute('href'); if (!href) return;

        // derive handle and use cache
        const handle = href.replace(/^\/+|\/+$/g,'').split('/').pop();
        let images = productCache.get(handle);

        if (!images) {
          const jsonUrl = new URL(href, location.origin);
          jsonUrl.pathname = jsonUrl.pathname.replace(/\/+$/,'') + '.js';
          try {
            const resp = await fetch(jsonUrl.toString(), { credentials: 'same-origin' });
            if (!resp.ok) return;
            const product = await resp.json();
            images = product?.images || [];
            productCache.set(handle, images);
          } catch (_) { return; }
        }

        if (!images || images.length < 2) return;

        const second = images[1];
        const attrs = buildResponsiveAttrs(second);

        const img2 = document.createElement('img');
        img2.className = 'motion-reduce';
        img2.loading = 'lazy';
        img2.decoding = 'async';
        img2.alt = card?.querySelector('.card__heading a')?.textContent?.trim() || '';
        if (attrs.srcset) img2.setAttribute('srcset', attrs.srcset);
        if (attrs.sizes)  img2.setAttribute('sizes', attrs.sizes);
        img2.src = attrs.src;

        // Default to cover to match Dawn unless first explicitly differs
        const firstImg = visuals[0].tagName === 'PICTURE' ? (visuals[0].querySelector('img') || visuals[0]) : visuals[0];
        const fit = firstImg ? getComputedStyle(firstImg).objectFit || 'cover' : 'cover';
        img2.style.objectFit = fit;

        m.appendChild(img2);
        m.classList.add('media--hover-effect');
      });

      await Promise.allSettled(tasks);
    }

    /* ----------------- Deduplicate product titles (low-CLS) ----------------- */
    function hcwCopyBlockMargins(from, to) {
      const cs = getComputedStyle(from);
      to.style.display = (cs.display === 'inline') ? 'inline' : 'block';
      to.style.marginTop = cs.marginTop;
      to.style.marginBottom = cs.marginBottom;
      to.style.marginLeft = cs.marginLeft;
      to.style.marginRight = cs.marginRight;
    }
    function hcwReplaceTag(el, newTag) {
      const repl = document.createElement(newTag);
      for (const {name, value} of [...el.attributes]) {
        if (name !== 'role' && name !== 'aria-level') repl.setAttribute(name, value);
      }
      repl.className = el.className;
      hcwCopyBlockMargins(el, repl);
      repl.innerHTML = el.innerHTML;
      el.replaceWith(repl);
      return repl;
    }
    function deDupeCardTitles(scopeEl){
      const root = scopeEl || mount;
      const cardSel = [
        '.card', '.card-wrapper', '.product-card',
        '.grid__item', 'li.grid__item',
        '.product-grid .grid__item',
        '.collection .grid__item'
      ].join(',');

      const titleSel = [
        'h2.card__heading','h3.card__heading',
        '.card-information__text','.product-card__title',
        '.full-unstyled-link',       // main product title link
        'h2','h3','[role="heading"]'
      ].join(',');

      const norm = s => (s || '').replace(/\s+/g,' ').trim().toLowerCase();

      root.querySelectorAll(cardSel).forEach(card => {
        if (card.dataset.hcwFixedTitles === '1') return;

        const candidates = [...card.querySelectorAll(titleSel)].filter(n => n.textContent && n.textContent.trim().length);
        if (!candidates.length) { card.dataset.hcwFixedTitles = '1'; return; }

        const linkTitle = card.querySelector('.full-unstyled-link');
        const canonicalText = norm(linkTitle ? linkTitle.textContent : candidates[0].textContent);

        let keptOne = false;
        candidates.forEach((node) => {
          const t = norm(node.textContent);
          const isHeading = /^h[1-6]$/i.test(node.tagName) || node.getAttribute('role') === 'heading';

          if (t === canonicalText) {
            if (!keptOne) {
              // Promote to H3 if not already a real heading (and not inside a link)
              if (!/^h[1-6]$/i.test(node.tagName) && !node.closest('h2,h3') && !node.closest('a')) {
                const promoted = hcwReplaceTag(node, 'h3');
                promoted.classList.add('card__heading');
              }
              keptOne = true;
            } else {
              // Demote duplicate to neutral node; keep spacing to avoid CLS
              if (isHeading) {
                const repl = hcwReplaceTag(node, 'div');
                repl.setAttribute('role','presentation');
              } else {
                node.removeAttribute('role');
                node.removeAttribute('aria-level');
              }
              const a = node.closest('a'); if (a) a.setAttribute('tabindex','-1');
            }
          } else {
            // Different text (vendor/subtitle) — ensure it isn't posing as a heading
            if (node.getAttribute('role') === 'heading') {
              node.removeAttribute('role'); node.removeAttribute('aria-level');
            }
          }
        });

        card.dataset.hcwFixedTitles = '1';
      });
    }

    /* ----------------- Render cycle ----------------- */
    async function renderFromUrl(absCollectionUrl){
      lockHeight();
      mount.classList.add('is-loading');
      if (!mount.innerHTML.trim()) mount.innerHTML = '<div class="loading">Loading…</div>';
      try {
        const html = await fetchSectionFromAbsoluteUrlAbortable(absCollectionUrl);
        if (typeof html !== 'string' || !html.trim()) throw new Error('Empty section HTML (check section id and collection).');

        let cleaned = html
          .replace(/\bcolor-scheme-\d+\b/g, '')
          .replace(/\bcolor-(?:scheme-\d+|\d+)\b/g, '')
          .replace(/\bgradient\b/g, '');

        const wrapper = document.createElement('div');
        wrapper.className = `hcw__remote ${schemeClasses}`;
        wrapper.innerHTML = cleaned;
        mount.innerHTML = '';
        mount.appendChild(wrapper);

        applyDawnImageRatioOverride();
        applyDawnGridOverrides();

        await hydrateMissingSecondImage(mount);

        // NEW: ensure one heading per card (low-CLS)
        deDupeCardTitles(mount);
        // Optional micro-tick to catch tiny async tweaks
        setTimeout(() => deDupeCardTitles(mount), 0);

        wire(); // bind interactions inside the new HTML
        document.dispatchEvent(new CustomEvent('collection:updated'));
      } catch (err) {
        if (err.name === 'AbortError') {
          // silently ignore aborted renders
        } else {
          console.error('[HCW] Render error:', err);
          mount.innerHTML = '<div class="loading" role="alert">Couldn’t render the collection section.</div>';
        }
      } finally {
        mount.classList.remove('is-loading');
        unlockHeight();
      }
    }

    // Initial render
    renderFromUrl(buildBaseUrlWithBlob(getSavedParams()));

    document.addEventListener('shopify:section:load', (e) => {
      if (e.detail && e.detail.sectionId === root.dataset.sectionId) {
        renderFromUrl(buildBaseUrlWithBlob(getSavedParams()));
      }
    });

    /* ----------------- Events ----------------- */
    function wire(){
      // Serialize ONLY the form you changed; build URL from that form’s action.
      mount.querySelectorAll('form').forEach((form) => {
        form.addEventListener('change', (e) => {
          const t = e.target;
          if (!t || !('name' in t)) return;

          queueMicrotask(() => {
            const u = new URL(form.getAttribute('action') || collectionUrl, location.origin);
            const fd = new FormData(form);
            const params = new URLSearchParams();
            for (const [k, v] of fd.entries()) if (v !== '' && v != null) params.append(k, v);
            params.delete('page'); // reset pagination on facet changes
            for (const [k, v] of params.entries()) u.searchParams.append(k, v);

            scheduleRender(u.toString());
          });
        }, false);

        form.addEventListener('submit', (e) => {
          e.preventDefault();
          queueMicrotask(() => {
            const u = new URL(form.getAttribute('action') || collectionUrl, location.origin);
            const fd = new FormData(form);
            const params = new URLSearchParams();
            for (const [k, v] of fd.entries()) if (v !== '' && v != null) params.append(k, v);
            params.delete('page');
            for (const [k, v] of params.entries()) u.searchParams.append(k, v);

            scheduleRender(u.toString());
          });
        }, false);
      });

      // Intercept same-collection links (chips, pagination, clear, sort links)
      const baseUrl = new URL(collectionUrl, location.origin);
      const basePath = baseUrl.pathname.replace(/\/+$/,'');
      mount.querySelectorAll('a[href]').forEach((a) => {
        a.addEventListener('click', (ev) => {
          const href = a.getAttribute('href'); if (!href) return;
          const abs = new URL(href, location.origin);

          const sameHost = abs.host === baseUrl.host;
          const sameCollection = sameHost && (abs.pathname === basePath || abs.pathname.startsWith(basePath + '/'));
          if (!sameCollection) return;

          ev.preventDefault();

          const cls = a.className || '';
          if (!/\bpagination|page\b/i.test(cls)) abs.searchParams.delete('page');

          scheduleRender(abs.toString());
        }, false);
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
